import { useQuery } from "@apollo/client";
import { Query } from "@onmo/graphql/graphql";
import { vodabucksBalanceGQL } from "../graphql";

export const useVodabucksBalance = (userId?: string, skip?: boolean) => {
  const { data } = useQuery<Pick<Query, "vodabucksBalance">>(
    vodabucksBalanceGQL,
    { variables: { input: { userId: userId || "" } }, skip },
  );

  return { vbBalance: data?.vodabucksBalance?.balance ?? 0 };
};
